import { DataLoader } from 'src/app/services/data-loader/data-loader';

/**
 * Session length distribution - the data shape behind UBI-1090. Emits the same column twice:
 * `session_length` as a NUMBER (value axis only) and `session_length_bucket` as a STRING label
 * (safe on a category axis). Bounds step by 5, so a value never equals its own category index.
 */
export const createCase12 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        this.emitter.emit({
            data: [
                { session_length: 0, session_length_bucket: '0-5', d3: 751601 },
                {
                    session_length: 5,
                    session_length_bucket: '5-10',
                    d3: 513912,
                },
                {
                    session_length: 10,
                    session_length_bucket: '10-15',
                    d3: 400264,
                },
                {
                    session_length: 15,
                    session_length_bucket: '15-20',
                    d3: 318568,
                },
                {
                    session_length: 20,
                    session_length_bucket: '20-25',
                    d3: 260247,
                },
                {
                    session_length: 25,
                    session_length_bucket: '25-30',
                    d3: 216635,
                },
                {
                    session_length: 30,
                    session_length_bucket: '30-35',
                    d3: 179947,
                },
                {
                    session_length: 35,
                    session_length_bucket: '35-40',
                    d3: 146908,
                },
                {
                    session_length: 40,
                    session_length_bucket: '40-45',
                    d3: 119792,
                },
                {
                    session_length: 45,
                    session_length_bucket: '45-50',
                    d3: 96014,
                },
                {
                    session_length: 50,
                    session_length_bucket: '50-55',
                    d3: 77889,
                },
                {
                    session_length: 55,
                    session_length_bucket: '55-60',
                    d3: 62730,
                },
                {
                    session_length: 60,
                    session_length_bucket: '60-65',
                    d3: 51661,
                },
                {
                    session_length: 65,
                    session_length_bucket: '65-70',
                    d3: 43623,
                },
                {
                    session_length: 70,
                    session_length_bucket: '70-75',
                    d3: 36266,
                },
                {
                    session_length: 75,
                    session_length_bucket: '75-80',
                    d3: 30033,
                },
                {
                    session_length: 80,
                    session_length_bucket: '80-85',
                    d3: 24954,
                },
                {
                    session_length: 85,
                    session_length_bucket: '85-90',
                    d3: 20813,
                },
                {
                    session_length: 90,
                    session_length_bucket: '90-95',
                    d3: 17260,
                },
                {
                    session_length: 95,
                    session_length_bucket: '95-100',
                    d3: 14536,
                },
                {
                    session_length: 100,
                    session_length_bucket: '100-105',
                    d3: 12408,
                },
                {
                    session_length: 105,
                    session_length_bucket: '105-110',
                    d3: 10251,
                },
                {
                    session_length: 110,
                    session_length_bucket: '110-115',
                    d3: 8879,
                },
                {
                    session_length: 115,
                    session_length_bucket: '115-120',
                    d3: 7378,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
